<template>
  <div class="text-black tab-content">
    <v-col class="flex-wrap" cols="12">
      <div class="mt-4 mb-3" style="font-size: 32px">
        AI Settings
      </div>
    </v-col>

    <!-- ************ -->
    <!-- prompt begin -->
    <!-- ************ -->
    <v-col class="flex-wrap" cols="12">
      <div class="font-weight-bold">
        AI prompt
        <help-dialog-workflow-ai-prompt
          #default="{ openDialog }"
          content-class="dialog-top-right"
        >
          <v-icon size="small" class="ml-2" @click="openDialog()"> mdi-help-circle-outline</v-icon>
        </help-dialog-workflow-ai-prompt>
      </div>
    </v-col>
    <v-form ref="formGenerateDiagram" v-model="validForm">
      <v-col class="flex-wrap" cols="12">
        <ai-description-input
          :text="workflow.aiDescription"
          :attachments="workflow.aiAttachments || []"
          :project-id="$route.params.projectId"
          :workflow-id="$route.params.id"
          @change-description="debouncedSaveAiDescription($event)"
          @change-attachments="saveAiAttachments($event)"
          label="Describe the business process or the scope of the project in natural language"
          hint="Which roles are involved in the process? What are the main steps?"
          :saving="isSavingAiDescription"
          ref="aiDescription"/>
      </v-col>
    </v-form>
    <!-- ********** -->
    <!-- prompt end -->
    <!-- ********** -->

    <v-col class="flex-wrap" cols="12">
      <div class="d-flex align-center justify-space-between">
        <!-- **************** -->
        <!-- AI version begin -->
        <!-- **************** -->
        <div class="my-5">
          <div class="d-flex align-center">
            <ai-version-selector v-model="aiVersion"/>
            <help-dialog-workflow-ai-version content-class="dialog-top-right" />
          </div>
          <ai-provider-key-indicator :ai-version="aiVersion" />
        </div>
        <!-- ************** -->
        <!-- AI version end -->
        <!-- ************** -->
        <!-- <ai-prompt-export #default="{ props }">
          <v-btn rounded="lg" size="large" variant="outlined" density="compact" v-bind="props" class="my-2 mr-4">Export AI
            Prompt
          </v-btn>
        </ai-prompt-export> -->
      </div>
    </v-col>
  </div>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import HelpDialogWorkflowAiPrompt from '@/components/HelpDialogWorkflowAiPrompt'
import HelpDialogWorkflowAiVersion from '@/components/HelpDialogWorkflowAiVersion'
import AiDescriptionInput from '@/components/AiDescriptionInput.vue'
import AiVersionSelector from '@/components/AiVersionSelector.vue'
import AiProviderKeyIndicator from '@/components/AiProviderKeyIndicator.vue'
import debounce from '@/utils/debounce'
import { mapState } from 'vuex'

export default {
  components: {
    AiDescriptionInput,
    AiVersionSelector,
    AiProviderKeyIndicator,
    HelpDialogWorkflowAiVersion,
    HelpDialogWorkflowAiPrompt
  },

  computed: {
    ...mapState({
      workflow: state => state.workflow.workflow,
      cardTypes: state => state.cardTypes.cardTypes
    })
  },

  data () {
    return {
      aiVersion: 11,
      createTypeOpen: false,
      createTypeFetching: false,
      validForm: true,
      isLoading: true,
      isSavingAiDescription: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      saveAiDescriptionDebouncer: debounce(e => {
        this.saveAiDescription(e)
      }, 1000)
    }
  },

  methods: {
    debouncedSaveAiDescription ({ description, skipDebounce }) {
      if (skipDebounce) {
        this.saveAiDescriptionDebouncer.cancel()
        this.saveAiDescription(description)
      } else {
        this.saveAiDescriptionDebouncer(description)
      }
    },
    async saveAiDescription (e) {
      this.isSavingAiDescription = true
      try {
        await workflowApi.updateWorkflowNoHistoryMutation(
          this.$route.params.projectId,
          {
            id: this.$route.params.id,
            expectedVersion: this.workflow.version,
            aiDescription: e
          }
        )
      } finally {
        this.isSavingAiDescription = false
      }
    },
    saveAiAttachments (attachments) {
      const aiAttachments = (attachments || []).map((attachment) => ({
        s3Key: attachment.s3Key,
        name: attachment.name,
        mimeType: attachment.mimeType,
        size: attachment.size
      }))
      workflowApi.updateWorkflowNoHistoryMutation(
        this.$route.params.projectId,
        {
          id: this.$route.params.id,
          expectedVersion: this.workflow.version,
          aiAttachments
        }
      )
    }
  }
}
</script>

<style scoped>
.tab-content {
  height: 900px;
}

:deep(.v-select__menu-icon) {
  display: none !important;
}

.sortableRow > div:focus-within {
  outline: 2px solid #4d90fe;
}

.sortable-chosen {
  background: #eee;
}

.sortable-ghost {
  background: #E5E3E1;
}

.sortable-ghost > div {
  opacity: 0.01;
}

[data-theme="dark"] .sortable-chosen,
[data-theme="dark"] .sortable-ghost {
  background: var(--light-3);
}

.p-3 {
  padding: 12px;
}

.gap-y-1 {
  row-gap: 8px;
}

#default-type {
  span {
    font-weight: 600;
  }
}
</style>
